const header = document.querySelector(".header")
const mobileMenuTrigger = document.querySelector('.mobile-menu-trigger')

if (header && mobileMenuTrigger) {
    const body = document.body
    mobileMenuTrigger.addEventListener("click", e => {
        e.target.classList.toggle("is-active")
        header.classList.toggle("mobile-menu-active")
        body.classList.toggle("mobile-menu-triggered")
    })
}